/* eslint-disable no-else-return */
import { useEffect, useState, useCallback } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Select, Button, Input, TimePicker, UploadList } from "components/core";
import { PageWrapper, Tab, TabPanel } from "components";
import { Maps } from "components/Maps";
import { useGlobalContext } from "context/GlobalContext";
import { withLoader } from "HOC";
import { useParams, useHistory } from "react-router-dom";
import { fetchBackend, uploadFile, uuidv4 } from "helpers";
import { ReportList } from "pages/private/ReportList";
import {
  optionsListStolen,
  ComplaintSchema,
  COMPLAINT,
  REPORT,
} from "constants/index";
import Typography from "@material-ui/core/Typography";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Logo from "assets/images/logo-default.png";

const SchemaMailbox = yup.object().shape({
  complaintReasonStolen: yup
    .string()
    .required("Seleccione la denuncia de robo"),
  // brandCar: yup.string().required("Seleccione una marca"),
  // modelCar: yup.string().required("Seleccione el modelo"),
  // platesCar: yup.string().required("Ingresa las placas"),
  colorCar: yup.string().required("Ingresa el color"),
  time: yup.string().required("Ingresa la hora del robo"),
  probableGuilty: yup
    .string()
    .required("Ingresa algo que nos ayude a indentificar a esta persona"),
  comments: yup
    .string()
    .required(
      "Compartenos más detalles para incrementar las posibilades de encontrar el vehículo"
    ),
  neighborhood: yup.string().required("Ingresa la colonia"),
  street: yup.string().required("Ingresa la calle"),
  city: yup.string().required("Ingresa la ciudad"),
  state: yup.string().required("Ingresa el estado"),
  reference: yup.string().required("Ingresa una referencia"),
  coordinates: yup.string().required("Ingresa una dirección"),
});

const Reports = ({ setLoading }) => {
  const [isChargin, setCharge] = useState(false);
  const [visbleMap, setVisibleMap] = useState(false);
  const [isLoadingModels, setLoadingModels] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isSectionVehicle, setSectionVehicle] = useState(false);
  const [state, setState] = useState(ComplaintSchema);
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [currentTab, setTab] = useState(0);

  const gContext = useGlobalContext();
  const { id: currentReport, car } = useParams();
  const history = useHistory();

  const {
    handleSubmit,
    register,
    control,
    errors,
    getValues,
    setError,
    setValue,
  } = useForm({
    resolver: yupResolver(SchemaMailbox),
  });

  const handleOnRemovePicture = useCallback(({ name }) => {
    const { mutimedia } = getValues();
    const data = mutimedia.filter((el) => el.name !== name);
    setValue("mutimedia", data); // ✅ performant
  }, []);

  const handleonUpdateAddress = useCallback(
    ({ coordinates, neighborhood, street, city, state: stateData }) => {
      setValue("neighborhood", neighborhood);
      setValue("street", street);
      setValue("city", city);
      setValue("state", stateData);
      setValue("coordinates", JSON.stringify(coordinates)); // ✅ performant
    },
    []
  );

  const updateReport = async (newObj) => {
    const { error } = await fetchBackend({
      method: "put",
      url: `complaint/${state._id}`,
      data: newObj,
    });

    if (!error) {
      setCharge(false);
      setTimeout(() => history.push("/"), 250);
    } else {
      setCharge(false);
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar actualizar el reporte, revisa la información",
        type: "warning",
      });
    }
  };

  const addReport = async (obj) => {
    const { error } = await fetchBackend({
      method: "post",
      url: "complaint",
      data: obj,
    });

    if (!error) {
      setCharge(false);
      setTimeout(() => history.push("/"), 250);
    } else {
      setCharge(false);
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar registrar el reporte, revisa la información",
        type: "warning",
      });
    }
  };

  const uploadPicture = async (item) => {
    const user = gContext.currentUser;
    return new Promise((res, rej) => {
      uploadFile(
        item,
        `complaint/${user._id}${user.name}/${uuidv4()}`,
        (url) => res(url),
        (percetage) => percetage === 100 && console.log("file upload"),
        (errorsStorage) => rej(errorsStorage)
      );
    });
  };

  const uploadPictures = async (file = []) => {
    const promises = file.map((item) => {
      return new Promise((res, rej) => uploadPicture(item).then(res, rej));
    });

    const pictures = await Promise.all(promises);
    return pictures;
  };

  const handleUploadData = async (obj, { images, videos }) => {
    const multimedia = {
      images: [],
      videos: [],
    };

    if (images.length > 0) {
      multimedia.images = await uploadPictures(images);
    }

    if (videos.length > 0) {
      multimedia.videos = await uploadPictures(videos);
    }

    if (isUpdate) {
      console.log("Is update");
    } else {
      const releasedObj = {
        ...obj,
        images: obj.images.concat(multimedia.images),
        videos: obj.videos.concat(multimedia.videos),
      };

      console.log(releasedObj);
      await addReport(releasedObj);
    }
  };

  const getMutimedia = (files = []) => {
    const images = files.filter((el) => el.type.split("/")[0] === "image");
    const videos = files.filter((el) => el.type.split("/")[0] === "video");
    return { images, videos };
  };

  const onSubmit = async (form, e) => {
    const {
      mutimedia = "",
      complaintReasonStolen = "",
      brandCar = "",
      modelCar = "",
      platesCar = "",
      colorCar = "",
      time = "",
      probableGuilty = "",
      comments = "",
      coordinates = "",
      neighborhood = "",
      street = "",
      city = "",
      state: stateForm,
      reference = "",
    } = form;

    const user = gContext.currentUser?._id || "";

    const currentTime = time ? new Date(time) : new Date();
    // `${currentTime.getHours()}:${currentTime.getMinutes()}`
    const obj = {
      user,
      brandCar: brands.find((el) => el._id === brandCar)?.brand || "",
      modelCar: models.find((el) => el._id === modelCar)?.name || "",
      platesCar,
      colorCar,
      time: currentTime.getTime(),
      dateCreated: new Date().getTime(),
      probableGuilty,
      comments,
      coordinates: JSON.parse(coordinates),
      complaintReasonStolen: [complaintReasonStolen],
      images: [],
      videos: [],
      place: {
        neighborhood,
        street,
        city,
        reference,
        state: stateForm,
      },
      status: "STOLEN",
      type: isSectionVehicle ? REPORT : COMPLAINT,
    };

    setCharge(true);
    await handleUploadData(obj, getMutimedia(mutimedia));
    // e.target.reset();
  };

  const getBrands = useCallback(async () => {
    const { error, response } = await fetchBackend({ url: "brand" });

    if (!error) {
      setBrands(response);
    } else {
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar obtener las marcas, revisa tu conexión a internet",
        type: "error",
      });
    }
  }, [gContext]);

  const getModels = useCallback(
    async ({ brand }) => {
      setLoadingModels(true);
      const { error, response } = await fetchBackend({
        url: `template/${brand}`,
      });

      setLoadingModels(false);

      if (!error) {
        setModels(response);

        if (!response.length) {
          gContext.toggleAlert({
            message:
              "No hay modelo disponibles para mostrar con este tipo de vehiculo y marca.",
            type: "warning",
          });
        }
      } else {
        gContext.toggleAlert({
          message:
            "Hubo un error al intentar obtener los modelos, revisa tu conexión a internet",
          type: "error",
        });
      }
    },
    [gContext]
  );

  const updateListModelVehicles = useCallback(async () => {
    const { brandCar } = getValues();

    if (brandCar) {
      await getModels({ brand: brandCar });
    } else {
      setError("brandCar", {
        type: "required",
        message: "Selecciona una marca valida",
      });
    }
  }, []);

  const toggleMap = () => {
    setVisibleMap((s) => !s);
  };

  const getSingleCar = useCallback(async (idVehicle) => {
    const { error, response } = await fetchBackend({ url: `car/${idVehicle}` });
    if (!error) {
      return response;
    } else {
      gContext.toggleAlert({
        message:
          "Hubo un error al intentar obtener los datos del vehiculo, revisa tu conexión a internet",
        type: "error",
      });
      return [];
    }
  }, []);

  const getInitialState = useCallback(async () => {
    await Promise.all([getBrands()]);
    setLoading(false);
  }, []);

  const getDefaultValues = useCallback(async () => {
    const isSectionVehicleBool =
      history.location.pathname.split("/")[2] === "vehiculo";

    if (isSectionVehicleBool && car) {
      const currentCar = await getSingleCar(car);
      const { model = "", color = "", plates = "", brand = "" } = currentCar[0];

      setValue("modelCar", model);
      setValue("brandCar", brand);
      setValue("platesCar", plates);
      setValue("colorCar", color);

      setSectionVehicle(isSectionVehicleBool);
      brand && getModels({ brand });
    }
  }, [history.location, car]);

  useEffect(() => {
    getInitialState();
    getDefaultValues();
  }, [getDefaultValues]);

  const handleChangeTab = (_, newValue) => {
    setTab(newValue);
  };

  return (
    <PageWrapper
      header={
        <>
          <Row start="xs">
            <Col md={12}>
              <Row center="xs">
                <h1>Denunciar Robo</h1>
              </Row>
            </Col>
          </Row>
          <Tab
            tabs={["DENUNCIAR", "MIS DENUNCIAS"]}
            onChange={handleChangeTab}
            value={currentTab}
          />
        </>
      }
    >
      <TabPanel value={currentTab} index={0}>
        <>
          <GoogleMaps
            className={`w-100 ${visbleMap ? "" : "dn"}`}
            onExit={toggleMap}
            onChange={handleonUpdateAddress}
          />
          <form
            onSubmit={handleSubmit(onSubmit)}
            className={`w-100 ${visbleMap ? "dn" : ""}`}
          >
            <Row className="pb4">
              <Input
                md={6}
                disabled
                name="user"
                placeholder="Usuario"
                defaultValue={gContext.currentUser?.name || ""}
              />
              <Controller
                name="time"
                control={control}
                defaultValue={new Date()}
                render={(props) => (
                  <TimePicker
                    md={6}
                    label="Hora del robo"
                    value={props.value}
                    onChange={(date) => props.onChange(date)}
                    error={errors.time?.message}
                  />
                )} // props contains: onChange, onBlur and value
              />
              <Input
                name="coordinates"
                placeholder="Ubicación"
                ref={register}
                disabled={isChargin}
                onClick={toggleMap}
                error={errors.coordinates?.message}
              />
              <Select
                md={12}
                name="complaintReasonStolen"
                valueOption="id"
                labelOption="title"
                label="Denuncia de robo"
                placeholder="Denuncia de robo"
                ref={register}
                disabled={isChargin}
                options={optionsListStolen}
                error={errors.complaintReasonStolen?.message}
              />
              <Select
                xs={12}
                md={6}
                name="brandCar"
                valueOption="_id"
                labelOption="brand"
                placeholder="Marca"
                label="Marca"
                disabled={isChargin}
                options={brands}
                ref={register}
                error={errors.brandCar?.message}
              />
              <Select
                xs={12}
                md={6}
                name="modelCar"
                label={`Modelo ${isLoadingModels ? "Cargando modelos" : ""}`}
                onClick={updateListModelVehicles}
                valueOption="_id"
                labelOption="name"
                placeholder="Da click para cargar los modelos disponibles"
                ref={register}
                disabled={isChargin}
                options={models}
                error={errors.modelCar?.message}
              />
              <Input
                md={6}
                name="platesCar"
                placeholder="Placas"
                ref={register}
                disabled={isChargin}
                error={errors.platesCar?.message}
              />
              <Input
                md={6}
                name="colorCar"
                placeholder="Color"
                ref={register}
                disabled={isChargin}
                error={errors.colorCar?.message}
              />

              <Col md={12} className="mt3 mb0 ph3">
                <Typography variant="caption" display="block" gutterBottom>
                  Lugar de los hechos
                </Typography>
              </Col>

              <Input
                md={6}
                name="street"
                placeholder="Calle"
                defaultValue={state.street}
                ref={register}
                error={errors.street?.message}
              />
              <Input
                md={6}
                name="neighborhood"
                placeholder="Colonia"
                defaultValue={state?.neighborhood}
                ref={register}
                error={errors.neighborhood?.message}
              />
              <Input
                md={6}
                name="city"
                placeholder="Minicipio/alcaldia"
                defaultValue={state?.city}
                ref={register}
                error={errors.city?.message}
              />
              <Input
                md={6}
                name="state"
                placeholder="Estado"
                defaultValue={state?.state}
                ref={register}
                error={errors.state?.message}
              />
              <Input
                md={6}
                name="reference"
                placeholder="Referencia"
                defaultValue={state?.reference}
                ref={register}
                error={errors.reference?.message}
              />
              <Input
                md={6}
                name="probableGuilty"
                placeholder="Posibles responsables"
                defaultValue={state?.probableGuilty}
                ref={register}
                error={errors.probableGuilty?.message}
              />
              <Input
                md={12}
                type="textarea"
                name="comments"
                placeholder="Comentarios adicionales"
                defaultValue={state?.comments}
                ref={register}
                error={errors.comments?.message}
              />
              <Controller
                name="mutimedia"
                control={control}
                defaultValue={[]}
                render={(props) => (
                  <UploadList
                    accept=".png, .jpg, .jpeg, .webp, .mp4, .avi, .mkv, .3gp"
                    onChange={(file) => props.onChange(file)}
                    value={props.value}
                    text="Agregar evidencia"
                    onRemove={handleOnRemovePicture}
                  />
                )} // props contains: onChange, onBlur and value
              />

              <Col md={12} className="mt2">
                <Button
                  htmlType="submit"
                  color="primary"
                  size="large"
                  className="w-100"
                  loading={isChargin}
                >
                  Enviar
                </Button>
              </Col>
            </Row>
          </form>
        </>
      </TabPanel>
      <TabPanel value={currentTab} index={1}>
        <ReportList />
      </TabPanel>
    </PageWrapper>
  );
};

export default withLoader(Reports, "Cargando mis reportes");

const GoogleMaps = ({ onExit, className, onChange }) => {
  const [currentStep, setStep] = useState(0);

  const handleOnNext = () => {
    setStep((s) => s + 1);
  };

  const handleOnPrev = () => {
    onExit();
  };

  return (
    <div className={`w-100 ${className}`}>
      {currentStep === 0 ? (
        <ProvidePermits onNext={handleOnNext} onPrev={handleOnPrev} />
      ) : (
        <Maps onExit={handleOnPrev} onChange={onChange} />
      )}
    </div>
  );
};

const ProvidePermits = ({ onNext, onPrev }) => {
  return (
    <Row center="xs" className="pb4">
      <Col md={12}>
        <img src={Logo} alt="logo" className="img-fluid m-auto mw5" />
      </Col>
      <Col md={12} className="mt4 mb4">
        <Typography variant="button" color="secondary" gutterBottom>
          CONFIRMACIÓN
        </Typography>
      </Col>
      <Col md={12} className="mb2">
        <Typography variant="body2" gutterBottom>
          ANTES DE LEVANTAR UN REPORTE REQUERIMOS QUE AUTORICES LA UBICACIÓN DE
          TU DISPOSITIVO PARA LEVANTAR EL REPORTE A LAS AUTORIDADES.
        </Typography>
      </Col>
      <Col md={12} className="mt2">
        <Button className="w-100" onClick={onNext}>
          Aceptar
        </Button>
      </Col>
      <Col md={12} className="mt2">
        <Button className="w-100 bg--gray" onClick={onPrev}>
          Rechazar
        </Button>
      </Col>
    </Row>
  );
};
